import styled from "styled-components";
import { Avatar as AntAvatar } from "antd";

export const Avatar = styled(AntAvatar)`
  font-weight: bold;
  background-color: #091694;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
`;
